module.exports = __webpack_public_path__ + "img/network-analyzer-md.80e2b651.svg";